import { valueToString } from '../../../Backend/src/GlobalFunction';

export function toAddress(address: number, byteAmount: number = 6): string {
  return '[' + valueToString(address, 16, byteAmount) + ']';
}
